import { createSelector } from 'reselect';
import { getFormat } from './simpleSelectors';
export default createSelector([getFormat], format => format && format.title || '');